import { defineStore } from 'pinia';

/**
 * v2.5.0 (Ship 11, M-3) — access-token store.
 *
 * Access tokens live here (in memory) instead of localStorage/sessionStorage.
 * Refresh tokens don't live here at all — auth-service sets them as an
 * httpOnly cookie the browser holds outside JS reach.
 *
 * NOT persisted. On page reload the store starts empty; ``authService.
 * ensureFreshAccessToken()`` re-populates by calling ``/api/v1/auth/refresh``
 * which the browser sends the refresh cookie with automatically.
 *
 * Separate from ``useAuthStore`` (which holds User profile + login/logout
 * actions) — this store is intentionally tiny and dependency-free so it
 * can be read from the axios interceptor without pulling the whole auth
 * store into the request path.
 */

interface AuthTokenState {
  accessToken: string | null;
  expiresAt: number | null; // ms since epoch (JWT `exp` × 1000)
}

export const useAuthTokenStore = defineStore('authToken', {
  state: (): AuthTokenState => ({
    accessToken: null,
    expiresAt: null,
  }),

  actions: {
    set(token: string, expiresAt: number | null): void {
      this.accessToken = token;
      this.expiresAt = expiresAt;
    },
    clear(): void {
      this.accessToken = null;
      this.expiresAt = null;
    },
  },
});
